module.exports = __webpack_public_path__ + "img/manuelle-reinigung.0c23c52.png";